export default __webpack_public_path__ + "static/media/2-4-3.eaf74816.jpg";